// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-n4T","title":"title-95k","panorama":"panorama-3Dn","panoramaWrapper":"panoramaWrapper-1TE","panoramaLogo":"panoramaLogo-1eD"};